module.exports = __webpack_public_path__ + "static/img/vertex-ok.ae4ffcf2.png";